import React from 'react';
import "./styles.css";
import { DisabledPrompt } from "@bcm-dev/bcms-vite";

/**
 * @function UIRadio
 * @param {STRING} className - Additional classes to add to the UIRadio.
 * @param {STRING} label - Lets us set a label to the left of the radio button.
 * @param {STRING} subText - Lets us set a sub text under the label of the radio button.
 * @param {STRING} value - Lets us set a value to the radio button.
 * @param {STRING} value - Lets us set a name to the radio button so only one can be selected.
 * @return {React.Component}
 * @exported true
 * @description The UIRadio has text to the left of a radio button that is underlined.
 * @example
 * <UIRadio className="added-class" value="true" label="Option1" />
 */
export default function UIRadio(props) {
  const className = props.className ?? "";
  const label = props.label ?? "";
  const subText = props.subText ?? "";
  const rightText = props.rightText !==undefined ? <p className="flex-width text-right"><span>{props.rightText}</span></p> : "";
  const checked = props.value !==undefined? {"checked":props.value }:{};
  const name = props.name ?? "";
  const point = props.dataPoint? {"data-point":props.dataPoint}:{}
  const radioPoint = props.dataPoint? {"data-point":props.dataPoint+"_Radio"}:{};
  const disabled = props.disabled === "true";

  const onChange = evt => props.onChange instanceof Function
    ? props.onChange(props.value ?? props.label, props.label)
    : () => undefined;

  return (
    <div className={className + " ui-radio flex-container flex-horizontal row-space-around-container"}>
      <label className="flex-width flex-container flex-horizontal align-center-container clickable" >
        <span className="flex-width">
          <p className="radio-label-text" {...point}>{label}</p>
          <span className="sub-text">{subText}</span>
        </span>
          {rightText}
          { !disabled && 
          <input type="radio" className="set-width clickable" name={name} {...checked} {...radioPoint} onChange={onChange}/>
          }
          { disabled && 
          <DisabledPrompt>
            <input type="radio" className="set-width clickable" name={name} {...checked} {...radioPoint} onChange={onChange}/>
          </DisabledPrompt>
          }
          </label>
    </div>
  );
}